<template>
  <div style="background-color: #edf4fc;">
    <div style="height: 0.001rem;"></div>
    <div style="overflow: hidden;border: 1px dashed rgb(223, 221, 221);margin: 0.1rem;">
      <el-row :gutter="20" style="border-bottom: 1px dashed rgb(223, 221, 221);">
        <el-col :span="12">
          <div>
            <div style="font-size: 0.13rem; margin: 0.1rem 0.1rem 0.05rem; color: #4f2f4f">根据学校名称搜索备考资料：</div>
            <div class="content-input">
              <el-input v-model="schoolName" placeholder="请输入学校名称" class="content-input-el" clearable @keyup.enter.native="schoolFind()"></el-input>
              <el-button type="primary" style="height: 0.34rem; margin-left: 0.2rem" @click="schoolFind()">搜索</el-button>
            </div>
          </div>
        </el-col>
        <el-col :span="12" style="border-left: 1px dashed rgb(223, 221, 221);">
          <div style="margin-left: -0.05rem;">
            <div style="font-size: 0.13rem; margin: 0.1rem 0.1rem 0.05rem; color: #4f2f4f">根据资料名称搜索备考资料：</div>
            <div class="content-input">
              <el-input v-model="dataName" placeholder="请输入资料名称" class="content-input-el" clearable @keyup.enter.native="dataFind()"></el-input>
              <el-button type="primary" style="height: 0.34rem; margin-left: 0.2rem" @click="dataFind()">搜索</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
      <div>
        <div style="font-size: 0.13rem; margin: 0.1rem 0.1rem 0.05rem; color: #4f2f4f">根据查询条件搜索备考资料：</div>
        <div class="content-table">
          <div class="content-table-1">
            <div class="content-table-11">院校所在地：</div>
            <div class="content-table-12">
              <el-radio-group v-model="idProvince" @change="changeSelectProvince">
                <el-radio label="全部" style="margin-right: 0.13rem; margin-bottom: 0.1rem">全部</el-radio>
                <el-radio label="北京" style="margin-right: 0.13rem; margin-bottom: 0.1rem">北京</el-radio>
                <el-radio label="天津" style="margin-right: 0.13rem; margin-bottom: 0.1rem">天津</el-radio>
                <el-radio label="河北" style="margin-right: 0.13rem; margin-bottom: 0.1rem">河北</el-radio>
                <el-radio label="山西" style="margin-right: 0.13rem; margin-bottom: 0.1rem">山西</el-radio>
                <el-radio label="内蒙古" style="margin-right: 0.13rem; margin-bottom: 0.1rem">内蒙古</el-radio>
                <el-radio label="辽宁" style="margin-right: 0.13rem; margin-bottom: 0.1rem">辽宁</el-radio>
                <el-radio label="吉林" style="margin-right: 0.13rem; margin-bottom: 0.1rem">吉林</el-radio>
                <el-radio label="黑龙江" style="margin-right: 0.13rem; margin-bottom: 0.1rem">黑龙江</el-radio>
                <el-radio label="上海" style="margin-right: 0.13rem; margin-bottom: 0.1rem">上海</el-radio>
                <el-radio label="江苏" style="margin-right: 0.13rem; margin-bottom: 0.1rem">江苏</el-radio>
                <el-radio label="浙江" style="margin-right: 0.13rem; margin-bottom: 0.1rem">浙江</el-radio>
                <el-radio label="安徽" style="margin-right: 0.13rem; margin-bottom: 0.1rem">安徽</el-radio>
                <el-radio label="福建" style="margin-right: 0.13rem; margin-bottom: 0.1rem">福建</el-radio>
                <el-radio label="江西" style="margin-right: 0.13rem; margin-bottom: 0.1rem">江西</el-radio>
                <el-radio label="山东" style="margin-right: 0.13rem; margin-bottom: 0.1rem">山东</el-radio>
                <el-radio label="河南" style="margin-right: 0.13rem; margin-bottom: 0.1rem">河南</el-radio>
                <el-radio label="湖北" style="margin-right: 0.13rem; margin-bottom: 0.1rem">湖北</el-radio>
                <el-radio label="湖南" style="margin-right: 0.13rem; margin-bottom: 0.1rem">湖南</el-radio>
                <el-radio label="广东" style="margin-right: 0.13rem; margin-bottom: 0.1rem">广东</el-radio>
                <el-radio label="广西" style="margin-right: 0.13rem; margin-bottom: 0.1rem">广西</el-radio>
                <el-radio label="海南" style="margin-right: 0.13rem; margin-bottom: 0.1rem">海南</el-radio>
                <el-radio label="重庆" style="margin-right: 0.13rem; margin-bottom: 0.1rem">重庆</el-radio>
                <el-radio label="四川" style="margin-right: 0.13rem; margin-bottom: 0.1rem">四川</el-radio>
                <el-radio label="贵州" style="margin-right: 0.13rem; margin-bottom: 0.1rem">贵州</el-radio>
                <el-radio label="云南" style="margin-right: 0.13rem; margin-bottom: 0.1rem">云南</el-radio>
                <el-radio label="西藏" style="margin-right: 0.13rem; margin-bottom: 0.1rem">西藏</el-radio>
                <el-radio label="陕西" style="margin-right: 0.13rem; margin-bottom: 0.1rem">陕西</el-radio>
                <el-radio label="甘肃" style="margin-right: 0.13rem; margin-bottom: 0.1rem">甘肃</el-radio>
                <el-radio label="青海" style="margin-right: 0.13rem; margin-bottom: 0.1rem">青海</el-radio>
                <el-radio label="宁夏" style="margin-right: 0.13rem; margin-bottom: 0.1rem">宁夏</el-radio>
                <el-radio label="新疆" style="margin-right: 0.13rem; margin-bottom: 0.1rem">新疆</el-radio>
                <el-radio label="香港" style="margin-right: 0.13rem; margin-bottom: 0.1rem">香港</el-radio>
                <el-radio label="澳门" style="margin-right: 0.13rem; margin-bottom: 0.1rem">澳门</el-radio>
                <el-radio label="台湾" style="margin-right: 0.13rem; margin-bottom: 0.1rem">台湾</el-radio>
                <el-radio label="其他" style="margin-right: 0.13rem; margin-bottom: 0.1rem">其他</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="content-table-2">
            <div class="content-table-21">报考专业：</div>
            <div class="content-table-22">
              <el-radio-group v-model="idMajor" @change="changeSelectMajor">
                <el-radio label="全部" style="margin-right: 0.13rem">全部</el-radio>
                <el-radio label="MBA" style="margin-right: 0.13rem">MBA</el-radio>
                <el-radio label="MEM-125601" style="margin-right: 0.13rem">MEM-125601</el-radio>
                <el-radio label="MEM-125602" style="margin-right: 0.13rem">MEM-125602</el-radio>
                <el-radio label="MPA" style="margin-right: 0.13rem">MPA</el-radio>
                <el-radio label="MTA" style="margin-right: 0.13rem">MTA</el-radio>
                <el-radio label="EMBA" style="margin-right: 0.13rem">EMBA</el-radio>
                <el-radio label="MPAcc" style="margin-right: 0.13rem">MPAcc</el-radio>
                <el-radio label="MAud" style="margin-right: 0.13rem">MAud</el-radio>
                <el-radio label="MEM-125603" style="margin-right: 0.13rem">MEM-125603</el-radio>
                <el-radio label="MEM-125604" style="margin-right: 0.13rem">MEM-125604</el-radio>
                <el-radio label="Mlis" style="margin-right: 0.13rem">Mlis</el-radio>
                <el-radio label="其他" style="margin-right: 0.13rem">其他</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div style="height: 0.06rem;"></div>
          <div class="content-table-2">
            <div class="content-table-21">报考年级：</div>
            <div class="content-table-22">
              <el-radio-group v-model="idGrade" @change="changeSelectGrade">
                <el-radio :label="20" style="margin-right: 0.13rem">全部</el-radio>
                <el-radio :label="2021" style="margin-right: 0.13rem">2021</el-radio>
                <el-radio :label="2022" style="margin-right: 0.13rem">2022</el-radio>
                <el-radio :label="2023" style="margin-right: 0.13rem">2023</el-radio>
                <el-radio :label="2024" style="margin-right: 0.13rem">2024</el-radio>
                <el-radio :label="2025" style="margin-right: 0.13rem">2025</el-radio>
                <el-radio :label="2026" style="margin-right: 0.13rem">2026</el-radio>
                <el-radio :label="2027" style="margin-right: 0.13rem">2027</el-radio>
                <el-radio :label="2028" style="margin-right: 0.13rem">2028</el-radio>
                <el-radio :label="2029" style="margin-right: 0.13rem">2029</el-radio>
                <el-radio :label="100" style="margin-right: 0.13rem">其他</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-body">
      <p style="font-size: 0.13rem">注：各招生单位的备考资料（链接）由其自主维护，如有疑问，请咨询发布单位。</p>
      <div style="margin-bottom: 0.1rem;">
        <div v-for="item in fileData" :key="item.id" class="divcolor">
          <a v-if="item.link === ''" href="javascript:void(0);" class="cell-link" @click="onUploadData(item)">
            <span class="cell-max">{{ item.filename }}</span>
            <span v-if="item.name !== ''" class="cell-name">（{{ item.name }}）</span>
          </a>
          <a v-if="item.link !== ''" :href="item.link" class="cell-link" target="_blank">
            <span class="cell-max">{{ item.filename }}</span>
            <span v-if="item.name !== ''" class="cell-name">（{{ item.name }}）</span>
          </a>
          <span class="cell-sapn">{{ item.link === '' ? '文件' : '链接' }}</span>
        </div>
      </div>
    </div>

    <div style="background-color: #edf4fc; padding-bottom: 0.2rem">
      <el-pagination :current-page="currentPage" :page-size="pageSize" background layout="prev, pager, next" :total="total" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
// 按需导入 API 接口
import { SelectDataDownloadSchoolName, SelectDataDownloadDataName, SelectDataDownload, filesDownloadById } from '@/api/datadownloadAPI'

export default {
  name: 'DataDownload',
  data() {
    return {
      dataName: '',
      schoolName: '',
      currentPage: 1,
      pageSize: 20,
      total: 1,
      fileData: [],
      idProvince: '全部',
      idMajor: '全部',
      idGrade: 20,
      idButton: 0
    }
  },
  created() {
    this.contentFind()
  },
  // 导航离开该组件的对应路由时调用
  // 可以访问组件实例 `this`
  beforeRouteLeave(to, from, next) {
    from.meta.top = window.scrollY
    setTimeout(() => {
      next()
    }, 0)
  },
  methods: {
    async contentFind() {
      const { data: res } = await SelectDataDownload(this.idProvince, this.idMajor, this.idGrade, this.currentPage, this.pageSize)
      this.fileData = res.data[2]
      this.total = res.data[0]
      this.idButton = 3
    },
    async schoolFind() {
      const { data: res } = await SelectDataDownloadSchoolName(this.schoolName, this.currentPage, this.pageSize)
      this.fileData = res.data[2]
      this.total = res.data[0]
      this.idButton = 2
    },
    async dataFind() {
      const { data: res } = await SelectDataDownloadDataName(this.dataName, this.currentPage, this.pageSize)
      this.fileData = res.data[2]
      this.total = res.data[0]
      this.idButton = 1
    },
    async changeSelectMajor() {
      this.currentPage = 1
      const { data: res } = await SelectDataDownload(this.idProvince, this.idMajor, this.idGrade, this.currentPage, this.pageSize)
      this.fileData = res.data[2]
      this.total = res.data[0]
      this.idButton = 3
    },
    async changeSelectProvince() {
      this.currentPage = 1
      const { data: res } = await SelectDataDownload(this.idProvince, this.idMajor, this.idGrade, this.currentPage, this.pageSize)
      this.fileData = res.data[2]
      this.total = res.data[0]
      this.idButton = 3
    },
    async changeSelectGrade() {
      this.currentPage = 1
      const { data: res } = await SelectDataDownload(this.idProvince, this.idMajor, this.idGrade, this.currentPage, this.pageSize)
      this.fileData = res.data[2]
      this.total = res.data[0]
      this.idButton = 3
    },
    async handleCurrentChange(val) {
      this.currentPage = val
      document.documentElement.scrollTop = 380
      if (this.idButton === 1) {
        const { data: res } = await SelectDataDownloadDataName(this.dataName, this.currentPage, this.pageSize)
        this.fileData = res.data[2]
        this.total = res.data[0]
      }
      if (this.idButton === 2) {
        const { data: res } = await SelectDataDownloadSchoolName(this.schoolName, this.currentPage, this.pageSize)
        this.fileData = res.data[2]
        this.total = res.data[0]
      }
      if (this.idButton === 3) {
        const { data: res } = await SelectDataDownload(this.idProvince, this.idMajor, this.idGrade, this.currentPage, this.pageSize)
        this.fileData = res.data[2]
        this.total = res.data[0]
      }
    },
    async onUploadData(item) {
      const { data: res } = await filesDownloadById(item.id)
      // 下载文件
      const blob = new Blob([res])
      const objectUrl = URL.createObjectURL(blob) // 创建URL
      const link = document.createElement('a')
      link.href = objectUrl
      // 这里是获取后台传过来的文件名
      link.setAttribute('download', item.filename)
      link.click() // 下载文件
      URL.revokeObjectURL(objectUrl) // 释放内存
    }
  }
}
</script>

<style lang="less" scoped>
a {
  color: #000000;
  text-decoration: none;
}
a p div span {
  font-size: 0.13rem;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Microsoft YaHei","Hiragino Sans GB","WenQuanYi Micro Hei",Arial,sans-serif;
}
.content-input {
  margin: 0.1rem;
  .content-input-el {
    width: 3rem;
  }
}
.content-table {
  margin: 0.1rem;
}
.content-table-1 {
  overflow: hidden;
  padding-top: 0.02rem;
}
.content-table-11 {
  float: left;
  width: 9%;
  font-size: 0.13rem;
}
.content-table-12 {
  float: left;
  width: 91%;
}
.content-table-2 {
  overflow: hidden;
}
.content-table-21 {
  float: left;
  width: 9%;
  font-size: 0.13rem;
  padding-top: 0.01rem;
}
.content-table-22 {
  float: left;
  padding-top: 0.05rem;
  width: 91%;
}
.content-body {
  overflow: hidden;
  padding-left: 0.1rem;
  padding-right: 0.1rem;
}
.divcolor {
  border: 1px dotted rgb(156, 156, 156);
  margin-bottom: 0.08rem;
  border-radius: 0.05rem;
}
.divcolor:hover {
  background-color: rgb(163, 252, 163);
}
.cell-link {
  display: inline-block;
  width: 8.8rem;
  font-size: 0.15rem;
  padding: 0.09rem 0 0.09rem 0.05rem;
}
.cell-max {
  display: inline-block;
  max-width: 7.2rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.cell-name {
  font-size: 0.13rem;
}
.cell-sapn {
  float: right;
  margin-right: 0.1rem;
  margin-top: 0.08rem;
  font-size: 0.15rem;
}
.el-button {
  width: 0.6rem;
  vertical-align: middle;
  text-align: center;
  padding: 0;
  font-size: 0.15rem;
  background-color: #061238;
  font-weight: 500;
}
.el-button > span {
  text-align: center;
}
.el-pagination {
  text-align: center;
}
/deep/ .el-radio__input {
  display: none;
}
/deep/ .el-radio {
  margin-right: 0.07rem;
  margin-bottom: 0.05rem;
}
/deep/ .el-radio__label {
  padding-left: 0;
  font-size: 0.13rem;
}
/deep/ .el-tabs__nav-scroll {
  border-bottom: none;
}
/deep/ .el-tabs__item {
  height: 0.24rem;
  line-height: 0.24rem;
  font-size: 0.13rem;
}
/deep/ .el-tabs__header {
  margin: 0 0 0.02rem;
}
/deep/ .el-form-item__label {
  padding: 0;
}
/deep/ .el-input__inner {
  font-size: 0.13rem;
}
</style>
